export const update = {
  updateSuccessfully: 'Update machine parts successfully!',
  updateFailed: 'Update machine parts failed!',
}
